const CopyActions = ({ onCopy, onCopyForManus }) => (
  <div className="pcm-copy-wrap" data-testid="copy-button-section">
    <button
      type="button"
      className="pcm-button pcm-button-primary pcm-copy-button"
      onClick={onCopy}
      data-testid="copy-brief-button"
    >
      <span className="pcm-button-icon" aria-hidden>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="9" y="9" width="13" height="13" rx="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      </span>
      Copy to Clipboard
    </button>
    <button
      type="button"
      className="pcm-button pcm-manus-button"
      onClick={onCopyForManus}
      data-testid="copy-manus-button"
    >
      Copy for Manus
    </button>
  </div>
);

export default CopyActions;